/* The Orb — homepage field (build 90).
   One invisible sphere; six constellations of real photographs on and just inside its surface.
   Pure DOM + transforms (no WebGL): each tile's point on the sphere is rotated and projected with perspective every frame;
   depth sets scale, opacity, a touch of softness and stacking. Slow drift when untouched, drag with soft inertia,
   hover brings a constellation forward, click focuses it, close returns the Orb exactly where it was. */
(function(){
  var root = document.querySelector('[data-orb]'); if(!root) return;
  var stage = root.querySelector('[data-ob-stage]'), space = root.querySelector('[data-ob-space]');
  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D = Math.PI / 180;
  var groups = [], tiles = [];

  /* build the model from the markup */
  /* the phone keeps every photograph: small tiles, many of them, are what give the sphere its shape */
  var isPhone0 = window.innerWidth < 1024, gAll = root.querySelectorAll('.ob-group'), gN = gAll.length, gI = 0;
  Array.prototype.forEach.call(gAll, function(el){
    if(isPhone0){ var yy = 1 - 2 * (gI + .5) / gN; el.setAttribute('data-lat', (Math.asin(yy) / D * .82).toFixed(1)); el.setAttribute('data-lon', ((gI * 137.508) % 360 - 180).toFixed(1)); }
    gI++;
    var g = { el: el, name: el.getAttribute('data-group'), lon: +el.getAttribute('data-lon') || 0, lat: +el.getAttribute('data-lat') || 0, tiles: [], hit: el.querySelector('.ob-hit'), card: el.querySelector('.ob-card'), lift: 0, dim: 0, sx: 0, sy: 0, d: 0 };
    Array.prototype.forEach.call(el.querySelectorAll('.ob-tile'), function(f){
      var img = f.querySelector('img'), iw = +(img && img.getAttribute('width')) || 4, ih = +(img && img.getAttribute('height')) || 5;
      var ar = Math.max(.62, Math.min(1.55, iw / ih));
      var sp0 = isPhone0 ? 2.1 : 1.4, lat = g.lat + (+f.getAttribute('data-dlat') || 0) * sp0, lon = g.lon + (+f.getAttribute('data-dlon') || 0) * sp0 / Math.max(.45, Math.cos(g.lat * D));
      var r = +f.getAttribute('data-r') || 1, w = +f.getAttribute('data-w') || 1;
      var t = { el: f, g: g, x: Math.cos(lat * D) * Math.sin(lon * D) * r, y: Math.sin(lat * D) * r, z: Math.cos(lat * D) * Math.cos(lon * D) * r, w: w, ar: ar, blur: -1 };
      g.tiles.push(t); tiles.push(t);
    });
    if(g.tiles.length) groups.push(g); else el.remove();
  });
  if(!tiles.length) return;

  /* geometry, from the stage's size: the Orb is larger than the frame, never seen whole */
  var W = 0, H = 0, R = 0, CX = 0, CY = 0, P = 0, BASE = 0, phone = false;
  function measure(){
    var r = stage.getBoundingClientRect(); W = r.width; H = r.height; phone = window.innerWidth < 1024;
    if(phone){ R = Math.min(W * .4, H * .4); CX = W * .5; CY = H * .5; BASE = R * .24; }   /* the whole Orb, contained, on the phone: many small photographs make the ball */
    else { R = Math.max(Math.min(W * .32, H * .66), 260); CX = W * .58; CY = H * .16 + R * 1.08; BASE = R * .27; }   /* desktop: a big Orb whose round crown sits just under the header, the ball running past the fold */
    P = R * (phone ? 2.4 : 3.2);   /* a stronger perspective on the phone: the back of the ball recedes */
    tiles.forEach(function(t){ var bw = BASE * t.w, bh = bw / t.ar; if(bh > BASE * 1.35){ bh = BASE * 1.35; bw = bh * t.ar; } t.bw = bw; t.bh = bh; t.el.style.width = bw.toFixed(1) + 'px'; t.el.style.height = bh.toFixed(1) + 'px'; });
  }

  /* state: the user's rotation (with inertia), a barely perceptible drift, a whisper of pointer parallax */
  var yaw = 8, pitch = -6, vy = 0, vp = 0, tYaw = null, tPitch = null;
  var drift = 0, driftSpeed = reduce ? 0 : 1, parX = 0, parY = 0, tParX = 0, tParY = 0;
  var hot = null, openG = null, saved = null, dragging = false;

  function wrap(a){ while(a > 180) a -= 360; while(a < -180) a += 360; return a; }
  /* it turns slowly on its own (about 2° a second) and breathes up and down, so it reads as a sphere */
  function driftYaw(){ return drift * (phone ? .0055 : .0021) + 5 * Math.sin(drift * .00017); }   /* a little faster on the phone, so the turning reads */
  function driftPitch(){ return 7 * Math.sin(drift * .00012 + 1.3); }

  function frame(dt){
    /* drift slows to a stop while a constellation is held or the Orb is in the hand */
    var want = (reduce || hot || openG || dragging) ? 0 : 1;
    driftSpeed += (want - driftSpeed) * .04; drift += dt * driftSpeed;
    if(!dragging && tYaw === null){ yaw += vy; pitch += vp; vy *= reduce ? 0 : .9; vp *= reduce ? 0 : .9; if(Math.abs(vy) < .002) vy = 0; if(Math.abs(vp) < .002) vp = 0; }
    if(tYaw !== null){ var k = reduce ? 1 : .075; yaw += wrap(tYaw - yaw) * k; pitch += (tPitch - pitch) * k; if(Math.abs(wrap(tYaw - yaw)) < .05 && Math.abs(tPitch - pitch) < .05){ yaw = tYaw; pitch = tPitch; tYaw = tPitch = null; } }
    pitch = Math.max(-38, Math.min(38, pitch));
    parX += (tParX - parX) * .05; parY += (tParY - parY) * .05;
    var Y = (yaw + driftYaw() + (openG ? 0 : parX)) * D, X = (pitch + driftPitch() + (openG ? 0 : parY)) * D;
    var cy = Math.cos(Y), sy = Math.sin(Y), cp = Math.cos(X), sp = Math.sin(X);

    groups.forEach(function(g){
      var liftT = g === openG ? 1 : (g === hot && !openG ? .45 : 0), dimT = (openG && g !== openG) ? 1 : ((hot && g !== hot) ? .55 : 0);
      var k2 = reduce ? 1 : .09; g.lift += (liftT - g.lift) * k2; g.dim += (dimT - g.dim) * k2;
      var sx = 0, sy2 = 0, sd = 0;
      g.tiles.forEach(function(t){
        var x1 = t.x * cy + t.z * sy, z1 = -t.x * sy + t.z * cy;
        var y2 = t.y * cp - z1 * sp, z2 = t.y * sp + z1 * cp;
        var z = z2 * R + g.lift * R * .28, s = P / (P - z);
        var d = Math.max(0, Math.min(1, (z2 + 1) / 2));
        var X2 = CX + x1 * R * s, Y2 = CY + y2 * R * s;
        var sc = s * (.78 + .32 * d) * (1 + g.lift * .22);
        var op = (.12 + .88 * Math.pow(d, 1.5)) * (1 - g.dim * .72);
        if(g === openG) op = Math.max(op, .98);
        var ry = Math.atan2(x1, Math.max(.2, z2)) * .32;
        t.el.style.transform = 'translate3d(' + (X2 - t.bw / 2).toFixed(1) + 'px,' + (Y2 - t.bh / 2).toFixed(1) + 'px,0) perspective(900px) rotateY(' + ry.toFixed(3) + 'rad) scale(' + sc.toFixed(3) + ')';
        t.el.style.opacity = op.toFixed(3);
        t.el.style.zIndex = String(Math.round(d * 1000) + (g === openG ? 2000 : g === hot ? 1000 : 0));
        var b = d < .16 ? 2 : (d < .32 ? 1 : 0); if(g.lift > .3) b = 0;
        if(b !== t.blur){ t.blur = b; t.el.style.filter = b === 2 ? 'blur(1.4px)' : (b === 1 ? 'blur(.7px)' : 'none'); }
        t.d = d; sx += X2; sy2 += Y2; sd += d;
      });
      var n = g.tiles.length; g.sx = sx / n; g.sy = sy2 / n; g.d = sd / n;
      place(g);
    });
  }

  /* the words: a small label near the constellation — faint when it faces you, fuller on hover, a card when in focus */
  function place(g){
    var c = g.card; if(!c) return;
    var front = g.d > .72 && !openG && !hot;
    c.classList.toggle('is-front', front);
    var vis = front || g === hot || g === openG;
    if(!vis && !c.__shown) return;
    c.__shown = vis;
    var right = g.sx < W * .62, x = right ? g.sx + BASE * .75 : g.sx - BASE * .75, y = g.sy - BASE * .35;
    if(phone){ x = Math.max(16, Math.min(W - 16, g.sx)); y = g.sy + BASE * .9; }
    c.classList.toggle('is-left', !right && !phone);
    c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
  }

  /* one loop, only while it is worth running: on screen, tab visible, no door open */
  var running = false, visible = true, last = 0;
  function active(){ return visible && !document.hidden && !html.classList.contains('is-door-open'); }
  function loop(ts){ if(!active()){ running = false; return; } var dt = last ? Math.min(64, ts - last) : 16; last = ts; frame(dt); requestAnimationFrame(loop); }
  function wake(){ if(running || !active()) return; running = true; last = 0; requestAnimationFrame(loop); }
  if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ visible = es[0].isIntersecting; wake(); }, { threshold: .02 }).observe(root); }
  document.addEventListener('visibilitychange', wake);
  document.addEventListener('door:close', function(){ setTimeout(wake, 50); });
  window.addEventListener('resize', function(){ measure(); frame(0); });
  /* the stage can move or change size after load (the phone layout moves it under the doors): measure again whenever it does */
  if('ResizeObserver' in window){ new ResizeObserver(function(){ measure(); frame(0); }).observe(stage); }

  function setHot(g){ if(hot === g) return; hot = g; groups.forEach(function(x){ x.el.classList.toggle('is-hot', x === g); }); root.classList.toggle('has-hot', !!g); wake(); }
  function openGroup(g){
    if(openG === g) return;
    if(!openG) saved = { yaw: yaw, pitch: pitch };      /* the exact place to come back to */
    if(openG){ openG.el.classList.remove('is-open'); openG.hit.setAttribute('aria-expanded', 'false'); }
    openG = g; vy = vp = 0; driftSpeed = 0;
    tYaw = yaw + wrap(-g.lon - driftYaw() - yaw); tPitch = Math.max(-38, Math.min(38, g.lat - driftPitch()));
    g.el.classList.add('is-open'); g.hit.setAttribute('aria-expanded', 'true');
    root.classList.add('has-open'); html.classList.add('has-of-open'); setHot(null); wake();
  }
  function closeGroup(){
    if(!openG) return;
    openG.el.classList.remove('is-open'); openG.hit.setAttribute('aria-expanded', 'false');
    openG = null; root.classList.remove('has-open'); html.classList.remove('has-of-open');
    if(saved){ tYaw = saved.yaw; tPitch = saved.pitch; saved = null; }
    wake();
  }
  function groupOf(el){ var ge = el && el.closest && el.closest('.ob-group'); if(!ge) return null; for(var i = 0; i < groups.length; i++){ if(groups[i].el === ge) return groups[i]; } return null; }

  /* pointer: hover focuses, drag turns (horizontal/diagonal on the phone; vertical scrolling stays the page's) */
  var down = null, moved = false, lastM = null, inStage = false;
  stage.addEventListener('pointerenter', function(e){ if(e.pointerType === 'mouse'){ inStage = true; lastM = null; } });
  stage.addEventListener('pointerdown', function(e){
    if(e.button !== 0 || (e.target.closest && e.target.closest('.ob-card'))) return;
    down = { x: e.clientX, y: e.clientY, yaw: yaw, pitch: pitch, t: e.timeStamp, lx: e.clientX, ly: e.clientY, lt: e.timeStamp, id: e.pointerId, type: e.pointerType };
    moved = false; vy = vp = 0; tYaw = tPitch = null;
  });
  window.addEventListener('pointermove', function(e){
    if(down && e.pointerId === down.id){
      var dx = e.clientX - down.x, dy = e.clientY - down.y;
      if(!moved && Math.hypot(dx, dy) > 6){
        if(down.type === 'touch' && Math.abs(dy) > Math.abs(dx) * 1.2){ down = null; return; }   /* a vertical swipe is the page's */
        moved = true; dragging = true; root.classList.add('is-dragging'); try { stage.setPointerCapture(down.id); } catch(err){}
        root.classList.add('was-touched');
      }
      if(moved){
        var k = phone ? .22 : .16;
        yaw = down.yaw + dx * k; pitch = down.pitch - dy * k * .8;
        var dt = Math.max(1, e.timeStamp - down.lt); vy = Math.max(-1.6, Math.min(1.6, (e.clientX - down.lx) * k * 16 / dt)); vp = Math.max(-1.2, Math.min(1.2, -(e.clientY - down.ly) * k * .8 * 16 / dt));
        down.lx = e.clientX; down.ly = e.clientY; down.lt = e.timeStamp; wake();
      }
      return;
    }
    /* build 205: hovering no longer turns the Orb (it felt like the mouse was caught) — it drifts on its own and turns only when dragged */
    if(false && e.pointerType === 'mouse' && !reduce && !openG && inStage){
      if(lastM){ var hk = hot ? .025 : .085, mx = e.clientX - lastM.x, my = e.clientY - lastM.y; if(Math.abs(mx) < 80 && Math.abs(my) < 80){ yaw += mx * hk; pitch -= my * hk * .7; vy = vy * .6 + mx * hk * .35; vp = vp * .6 - my * hk * .25; wake(); } }
      lastM = { x: e.clientX, y: e.clientY };
    }
  });
  function up(){ if(!down) return; down = null; if(dragging){ dragging = false; root.classList.remove('is-dragging'); if(reduce){ vy = vp = 0; } } }
  window.addEventListener('pointerup', up); window.addEventListener('pointercancel', function(){ up(); moved = false; });
  stage.addEventListener('pointerover', function(e){ if(e.pointerType === 'touch' || dragging || openG) return; var g = groupOf(e.target); if(g && e.target.closest('.ob-tile')) setHot(g); });
  stage.addEventListener('pointerleave', function(){ setHot(null); inStage = false; lastM = null; });
  stage.addEventListener('pointerout', function(e){ if(!hot || dragging) return; var to = e.relatedTarget; if(!to || !to.closest || !to.closest('.ob-tile, .ob-card') || groupOf(to) !== hot) setHot(null); });
  stage.addEventListener('click', function(e){
    if(moved){ moved = false; e.preventDefault(); return; }
    if(e.target.closest('.ob-card a')) return;                        /* the way in: a normal link, routed like any other */
    var g = groupOf(e.target), onTile = e.target.closest('.ob-tile, .ob-hit, .ob-card');
    if(g && onTile){ if(openG === g && !e.target.closest('.ob-hit')) return; openGroup(g); return; }
    closeGroup();
  });
  /* keyboard: Tab reaches each constellation; Enter focuses it; its link is next; Escape returns */
  groups.forEach(function(g){
    if(!g.hit) return;
    g.hit.addEventListener('focus', function(){ if(!openG) setHot(g); });
    g.hit.addEventListener('blur', function(){ if(hot === g) setHot(null); });
    g.hit.addEventListener('click', function(e){ e.stopPropagation(); if(openG === g){ closeGroup(); } else { openGroup(g); } });
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && openG){ var g = openG; closeGroup(); if(g.hit) g.hit.focus(); } });
  document.addEventListener('door:open', closeGroup);

  measure(); frame(16); wake();
  if(document.readyState !== 'complete') window.addEventListener('load', function(){ measure(); frame(0); });
})();
